import styled from "styled-components";
import { ArrowRight, Sparkles } from "lucide-react";
import { useNavigate } from "react-router-dom";
const FinalCTASection = styled.section`
  padding: 140px 24px 160px;
  background:
    radial-gradient(circle at top left, rgba(245, 158, 11, 0.14), transparent 30%),
    radial-gradient(circle at top right, rgba(56, 189, 248, 0.14), transparent 34%);
  text-align: center;
`;

const CTAContainer = styled.div`
  max-width: 820px;
  margin: auto;
`;

const CTATitle = styled.h2`
  font-size: clamp(30px, 5vw, 42px);
  font-weight: 900;
  line-height: 1.2;
  margin-bottom: 22px;
`;

const CTASub = styled.p`
  font-size: 18px;
  line-height: 1.7;
  color: #9ca3af;
  margin-bottom: 46px;
`;

const CTAButton = styled.button`
  padding: 18px 34px;
  border-radius: 16px;
  font-size: 18px;
  font-weight: 800;
  cursor: pointer;
  border: none;
  color: white;
  display: inline-flex;
  align-items: center;
  gap: 10px;

  background: linear-gradient(90deg, #f59e0b, #d97706);
  box-shadow: 0 18px 60px rgba(245, 158, 11, 0.32);
  transition: all 0.25s ease;

  &:hover {
    transform: translateY(-3px) scale(1.03);
    box-shadow: 0 28px 80px rgba(245, 158, 11, 0.42);
  }
`;

const CTANote = styled.p`
  margin-top: 18px;
  font-size: 14px;
  color: #9ca3af;
  display: flex;
  justify-content: center;
  gap: 6px;
  align-items: center;
`;
export function FinalCTA() {
  const navigate = useNavigate();
  return (
    <FinalCTASection>
      <CTAContainer>
        <CTATitle>
          Stop guessing your career.
          <br />
          Get clarity today.
        </CTATitle>

        <CTASub>
          It takes just 5 minutes. You’ll know where you stand, which path fits
          you best, and what should become your next roadmap.
        </CTASub>

        <CTAButton onClick={() => navigate("/choose-career-page")}>
          Start Free Career Clarity Test
          <ArrowRight size={22} />
        </CTAButton>

        <CTANote>
          <Sparkles size={14} />
          Free · No login required · Instant result
        </CTANote>
      </CTAContainer>
    </FinalCTASection>
  );
}
